import { useQuery } from '@tanstack/react-query';

import { useRequest, type QueryFunction, type RequestQuery } from '../common';
import { getAccountsKey } from './keys';

export type TrustedVendor = {
  id: number;
  name: string;
};

export const getTrustedVendorListQueryKey = (query?: RequestQuery) =>
  [...getAccountsKey(), 'trustedVendors', query] as const;

export const useTrustedVendorList: QueryFunction<
  TrustedVendor[],
  [],
  ReturnType<typeof getTrustedVendorListQueryKey>
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey: getTrustedVendorListQueryKey(query),
    queryFn: ({ signal }) =>
      request('/accounts/trusted_vendors', {
        query,
        init: { signal },
      }),
  });
};
